module.exports = __webpack_public_path__ + "img/19.b89272a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/19.png
// module id = Cuq/
// module chunks = 1